module.exports = {
          srcSet: __webpack_public_path__ + "b99233b2.jpg"+" 700w"+","+__webpack_public_path__ + "86cea8e3.jpg"+" 1400w"+","+__webpack_public_path__ + "a445da80.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "b99233b2.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "86cea8e3.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "a445da80.jpg",width: 2048,height: 1536}],
          src: __webpack_public_path__ + "b99233b2.jpg",
          toString:function(){return __webpack_public_path__ + "b99233b2.jpg"},
          
          width: 700,
          height: 525
        }